export type KnowledgeScope = 'personal' | 'enterprise'

export const KNOWLEDGE_SCOPE_META: Record<
  KnowledgeScope,
  { title: string; description: string; searchHint: string }
> = {
  personal: {
    title: '个人知识库',
    description: '录入、上传文档并自动切片向量化，供对话与检索使用。',
    searchHint: '个人知识库',
  },
  enterprise: {
    title: '企业知识库',
    description: '上传文档后自动切片并向量化，供对话与检索使用。',
    searchHint: '企业知识库',
  },
}

export function scopeQuery(scope: KnowledgeScope): { scope: KnowledgeScope } {
  return { scope }
}

/** 下拉/筛选：企业库在上，个人库在下 */
export const KNOWLEDGE_SCOPE_OPTIONS: { value: KnowledgeScope; label: string }[] = [
  { value: 'enterprise', label: '企业知识库' },
  { value: 'personal', label: '个人知识库' },
]

export const KNOWLEDGE_SCOPE_OPTIONS_SHORT: { value: KnowledgeScope; label: string }[] = [
  { value: 'enterprise', label: '企业库' },
  { value: 'personal', label: '个人库' },
]

export const CHUNK_STRATEGY_OPTIONS = [
  { value: 'fixed', label: '固定字符窗口（默认）' },
  { value: 'paragraph', label: '按段落' },
  { value: 'markdown', label: '按 Markdown 标题' },
] as const
